import type { Custodian } from 'models/custodian';
import type { CostAndCharge } from 'models/streaming/costsAndCharges';
import type { UnderlyingCodeType } from 'models/underlying/base';
import type { Observable } from 'rxjs';
import type { BasketOptimizerResultRow } from 'state/advisory/basket-optimizer/model';
import type { DataById } from 'state/formData/formData.model';
import type { GreeksTable } from 'state/quotes/details/details.model';
import type { IRegulatoryResource } from 'state/regulatoryDocuments';
import type { QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';
import type { HttpCall, IHttpClient } from 'utils/http/httpClient.model';

export interface ProductSummaryApi {
  sendMaiInHtmlFormat: (request: SendMailInHtmlFormatRequest) => Observable<HttpCall<SendMailResponse>>;
}

export interface SendMailRequest {
  content: string;
  subject: string;
}

export interface SendMailInHtmlFormatRequest {
  availableCustodians: Custodian[];
  externalQuoteId?: string;
  formData: DataById;
  isDarkMode: boolean;
  isSolved: boolean;
  solveResult?: number;
  kidDocumentation?: IRegulatoryResource[];
  productGovernanceDocumentation?: IRegulatoryResource[];
  optimizedBasketResults: BasketOptimizerResultRow[];

  costsAndChargesResults: CostAndCharge[];
  costsAndChargesCurrency: string;

  costsAndChargesDescription: string;
  defaultUnderlyingCodeType: UnderlyingCodeType;
  languageCode?: string;
  quoteWorkspaceVersion?: QuoteWorkspaceVersion;
  mustForceAdvancedMode?: boolean;
  greeks?: GreeksTable;
  equityGreeks?: GreeksTable;
}

export interface SendMailResponse {}

export function ProductSummaryApiConnector(http: IHttpClient): ProductSummaryApi {
  return {
    sendMaiInHtmlFormat(request: SendMailInHtmlFormatRequest): Observable<HttpCall<SendMailResponse>> {
      const url = 'api/v1/static-form/product-summary/send-html-mail';

      return http.postJSON<SendMailResponse>({
        url,
        body: request,
      });
    },
  };
}
